import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	wasThisHelpful: {
		id: 'issue-smart-request-summary.footer.feedback.was-this-helpful',
		defaultMessage: 'Was this helpful?',
		description: 'Feedback question asked whether the comment summary was helpful for the user',
	},
	helpfulLabel: {
		id: 'issue-smart-request-summary.footer.feedback.helpful-label',
		defaultMessage: 'This summary was helpful',
		description: 'Label for button user can click when they find a comment summary to be helpful',
	},
	unhelpfulLabel: {
		id: 'issue-smart-request-summary.footer.feedback.unhelpful-label',
		defaultMessage: 'This summary was unhelpful',
		description: 'Label for button user can click when they find a comment summary to be unhelpful',
	},
	thanks: {
		id: 'issue-smart-request-summary.footer.feedback.thanks',
		defaultMessage: 'Thanks for your feedback!',
		description: 'Message shown after feedback is submitted for a comment summary',
	},
	turnOffAutoSummarize: {
		id: 'issue-smart-request-summary.footer.feedback.turn-off-auto-summarize',
		defaultMessage: 'Turn automatic summaries off',
		description: 'Label for turning off auto summarize feature',
	},
	turnOnAutoSummarize: {
		id: 'issue-smart-request-summary.footer.feedback.turn-on-auto-summarize',
		defaultMessage: 'Turn automatic summaries on',
		description: 'Label for turning on auto summarize feature',
	},
	autoSummarizeDisabledConfirmation: {
		id: 'issue-smart-request-summary.footer.feedback.auto-summarize-enabled-confirmation',
		defaultMessage: 'Automatic summaries are turned off',
		description: 'Confirmation label for auto-summarization disabled',
	},
	autoSummarizeEnabledConfirmation: {
		id: 'issue-smart-request-summary.footer.feedback.auto-summarize-disabled-confirmation',
		defaultMessage: 'Automatic summaries are turned on',
		description: 'Confirmation label for auto-summarization enabled',
	},
});
